"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetHeader = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var classnames_1 = __importDefault(require("classnames"));
var useResetStyles_1 = require("../../../hooks/useResetStyles");
var useHeaderStyles_1 = require("../../../hooks/useHeaderStyles");
exports.ApprovalSheetHeader = function (props) {
    var stateCode = props.stateCode;
    var theme = core_1.useTheme();
    var classes = useHeaderStyles_1.useHeaderStyles();
    var resetClasses = useResetStyles_1.useResetStyles();
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between", alignItems: "baseline", wrap: "nowrap", className: resetClasses.resetCss },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "flex-start", alignItems: "center", wrap: "nowrap", spacing: 8 },
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Typography, { variant: "h6", component: "h2" },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "approvalTabName" }))))),
        react_1.default.createElement(core_1.Grid, { item: true }, stateCode && (react_1.default.createElement(core_1.Grid, { container: true, alignItems: "baseline", spacing: 2, wrap: "nowrap", component: "dl", className: resetClasses.resetCss },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Box, { color: theme === null || theme === void 0 ? void 0 : theme.palette.primary.light },
                    react_1.default.createElement(core_1.Typography, { variant: "body1", component: "dt", className: resetClasses.resetCss },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "approvalSheetStateLabel" })))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { variant: "body2", component: "dd", noWrap: true, className: classnames_1.default(classes.headerValue, resetClasses.resetCss) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "approvalSheetStates." + stateCode }))))))));
};
